import { postJsMessage } from '../../../bridge';
import API from '../../../api';
import { isAvailable } from '../../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from 'types/index';
import type { ShareCapabilities, ShareData, SaveImageData } from './types';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.getShareCapabilities
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.6.5+
 * android    6.6.5+
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function getShareCapabilities(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<ShareCapabilities>> {
  await isAvailable('mobile.getShareCapabilities');
  return postJsMessage(API.getShareCapabilities, {}, options);
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.shareContent
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.6.5+
 * android    6.6.5+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function shareContent(
  shareData: ShareData,
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<{}>> {
  await isAvailable('mobile.shareContent');

  const data = {
    ...shareData,
    contentType: (shareData as any).contentType || 'text/plain',
  };

  return postJsMessage(API.shareContent, data, { timeout: 0, ...options });
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * mobile.saveImageToAlbum
 *
 * [PLATFORM]
 * mac        NotSupport
 * windows    NotSupport
 * linux      NotSupport
 * ios        6.6.5+
 * android    6.6.5+
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function saveImageToAlbum(
  imageData: SaveImageData,
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<{}>> {
  await isAvailable('mobile.saveImageToAlbum');

  return postJsMessage(API.saveImageToAlbum, imageData, options);
}

export type {
  ShareCapabilities,
  ShareData,
  SaveImageData,
  SMSContentType,
  EmailContentType,
  TelContentType,
  ImageContentType,
  PDFContentType,
  OtherAppContentType,
} from './types';
